import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Alert } from "../feedback/Alert.js";
import { Button } from "../form/Button.js";
import { TextField } from "../form/TextField.js";
import { Stack } from "../layout/Stack.js";
/**
 * An email and a password, and a button.
 *
 * Deliberately no "create account" and no "forgot password": accounts with a
 * password are provisioned by a super-admin, and so are resets. A link to a
 * flow that does not exist would be a dead end on the login page.
 *
 * The typed values stay in component state. That is the one place they belong:
 * a password in the URL would be kept in history and logs, and the URL-state
 * rule is for state a person navigates to, not for unsaved input.
 */
export const EmailPasswordForm = ({ onSubmit, disabled = false, submitLabel = "Sign in with email", }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await onSubmit({ email: email.trim(), password });
            // Left submitting on success: the caller navigates away, and re-enabling
            // the button for the moment in between invites a second submit.
        }
        catch (err) {
            setError(err instanceof Error && err.message ? err.message : "Sign-in failed. Try again.");
            setSubmitting(false);
        }
    };
    return (_jsxs(Stack, { component: "form", spacing: 2, onSubmit: handleSubmit, sx: { width: "100%" }, noValidate: true, children: [error && _jsx(Alert, { severity: "error", children: error }), _jsx(TextField, { label: "Email", type: "email", name: "email", autoComplete: "username", value: email, onChange: (event) => setEmail(event.target.value), disabled: disabled || submitting, fullWidth: true, required: true }), _jsx(TextField, { label: "Password", type: "password", name: "password", autoComplete: "current-password", value: password, onChange: (event) => setPassword(event.target.value), disabled: disabled || submitting, fullWidth: true, required: true }), _jsx(Button, { type: "submit", variant: "outlined", size: "large", fullWidth: true, disabled: disabled || submitting || email.trim() === "" || password === "", sx: { minHeight: 48 }, children: submitting ? "Signing in..." : submitLabel })] }));
};
//# sourceMappingURL=EmailPasswordForm.js.map